import React, { useRef } from "react"
import ReactModal from "react-modal"
import { RemoveScroll } from "react-remove-scroll"
import styled from "styled-components"
import { rem } from "polished"

import { ReactComponent as DeleteSvg } from "../../assets/icons/delete.svg"

const ReactModalStyled = styled(ReactModal)`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: ${({ theme }) => theme.zindex.modal};
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
`

const RemoveScrollStyled = styled(RemoveScroll)`
  width: 100%;
  height: 100%;
  position: relative;
`

const Close = styled.button.attrs({ type: `button` })`
  width: ${rem(40)};
  height: ${rem(40)};
  padding: ${rem(3)};
  position: absolute;
  z-index: 999;
  top: ${rem(10)};
  right: ${rem(10)};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.5;
  }

  svg {
    width: 100%;
    height: 100%;
    padding: 0.6em;
    display: block;
  }
`

const Modal = ({
  children,
  onRequestClose,
  title,
  closeButton = true,
  closeOnOutsideClick = true,
  isOpen = false,
  translations,
}) => {
  const outsideRef = useRef()

  const outsideClick = (e) => {
    if (e.target === outsideRef.current && closeOnOutsideClick) {
      e.preventDefault()
      onRequestClose(e)
    }
  }

  return (
    <ReactModalStyled
      isOpen={isOpen}
      defaultStyles={{}}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
      contentLabel={title}
    >
      <RemoveScrollStyled ref={outsideRef} onClick={outsideClick}>
        {closeButton && (
          <Close onClick={onRequestClose} title={translations.global.close}>
            <DeleteSvg aria-label={translations.global.close} />
          </Close>
        )}

        {children}
      </RemoveScrollStyled>
    </ReactModalStyled>
  )
}

export default Modal
